import { useMemo } from "react";
import { useToolbarCssVariables } from "../ToolbarRoot/context/hooks/useToolbarCssVariables.js";
import { useToolbarStoreId } from "../ToolbarRoot/context/hooks/useToolbarStoreId.js";
import { useToolbarApi, useToolbarState } from "../store/store.js";
function useToolbar() {
  const storeId = useToolbarStoreId();
  const cssVariables = useToolbarCssVariables();
  const state = useToolbarState(storeId);
  const api = useToolbarApi(storeId);
  return useMemo(() => ({ ...state, ...api, cssVariables }), [api, cssVariables, state]);
}
export {
  useToolbar
};
//# sourceMappingURL=useToolbar.js.map
